import { Box, Checkbox, FormControlLabel } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import DescriptionIcon from "../../assets/SVG/descriptionIcon";
import InputLoginForm from "../../pages/auth/inputLoginForm";

export function CheckBoxBranch({
  label,
  setChecked,
  checked,
  onChange,
  width,
  ...props
}) {
  //   const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  return (
    <FormControlLabel
      sx={{
        width: width || "250px",
        mr: "-10px",
        my: "10px",
        "& .MuiButtonBase-root": { color: "var(--emr-darkblue) !important" },
        "& .MuiTypography-root": {
          fontSize: "16px",
          fontWeight: "600",
          color: "var(--emr-primary-color-text)",
          // width:dinamic?"fit-content": "210px"
        },
      }}
      {...props}
      control={
        <Checkbox checked={checked} onChange={onChange || handleChange} />
      }
      label={label}
    />
  );
}
export default function ChekboxListBranch({ dataForm, setDataForm, update }) {
  const [checkedEducation, setCheckedEducation] = useState();
  const [checkedOptometry, setCheckedOptometry] = useState();
  const [checkedMidwifery, setCheckedMidwifery] = useState();
  const [checkedAudiologists, setCheckedAudiologists] = useState();
  const [checkedPsychology, setCheckedPsychology] = useState();
  const [checkedLaboratory, setCheckedLaboratory] = useState();
  const [checkedPhysiotherapy, setCheckedPhysiotherapy] = useState();
  const [checkedDentistry, setCheckedDentistry] = useState();
  const [checkedErrand, setCheckedErrand] = useState();

  ////

  const [adultEducation, setAdultEducation] = useState();

  // console.log(dataForm);
  useEffect(() => {
    if (adultEducation)
      setDataForm({
        ...dataForm,
        adultEducation: "adultEducation",
      });
  }, [adultEducation]);

  useEffect(() => {
    if (update) {
      setCheckedEducation(true);
      setCheckedOptometry(true);
      setCheckedMidwifery(true);
      setCheckedAudiologists(true);
      setCheckedPsychology(true);
      setCheckedLaboratory(true);
      setCheckedPhysiotherapy(true);
      setCheckedDentistry(true);
      setCheckedErrand(true);
    }
  }, [update]);

  return (
    <Box mt="30px">
      <Box display="flex">
        <CheckBoxBranch
          label="آموزش"
          setChecked={setCheckedEducation}
          checked={checkedEducation}
        />
        {checkedEducation && (
          <>
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({ ...dataForm, adultEducation: e.target.checked })
              }
              checked={dataForm.adultEducation}
              label=" آموزش بزرگسالان"
            />
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({ ...dataForm, childEducation: e.target.checked })
              }
              checked={dataForm.childEducation}
              label="آموزش کودکان"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="بینایی سنجی"
          setChecked={setCheckedOptometry}
          checked={checkedOptometry}
        />
        {checkedOptometry && (
          <>
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({ ...dataForm, freeGlass: e.target.checked })
              }
              checked={dataForm.freeGlass}
              label="اهدای رایگان عینک"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="شنوایی سنجی"
          setChecked={setCheckedAudiologists}
          checked={checkedAudiologists}
        />
        {checkedAudiologists && (
          <>
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({ ...dataForm, freeHearingAids: e.target.checked })
              }
              checked={dataForm.freeHearingAids}
              label="اهدای رایگان سمعک"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="مامایی"
          setChecked={setCheckedMidwifery}
          checked={checkedMidwifery}
        />
        {checkedMidwifery && (
          <>
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({ ...dataForm, popEsmirTest: e.target.checked })
              }
              checked={dataForm.popEsmirTest}
              label="تست پاپ اسمیر"
            />
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({ ...dataForm, cancerTest: e.target.checked })
              }
              checked={dataForm.cancerTest}
              label="غربالگری سرطان پستان"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="روانشناسی"
          setChecked={setCheckedPsychology}
          checked={checkedPsychology}
        />
        {checkedPsychology && (
          <>
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  socialWorkAssistance: e.target.checked,
                })
              }
              checked={dataForm.socialWorkAssistance}
              label="مددکاری اجتماعی"
            />
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  quitAddiction: e.target.checked,
                })
              }
              checked={dataForm.quitAddiction}
              label="ترک اعتیاد"
            />
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  familyPsychology: e.target.checked,
                })
              }
              checked={dataForm.familyPsychology}
              label="روانشناسی کودک و خانواده"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="آزمایشگاه"
          setChecked={setCheckedLaboratory}
          checked={checkedLaboratory}
        />
        {checkedLaboratory && (
          <>
            <CheckBoxBranch
              style={{ width: "200px" }}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  urineAnalysis: e.target.checked,
                })
              }
              checked={dataForm.urineAnalysis}
              label="تست آنالیز ادراری"
            />
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  bloodCellsCountTest: e.target.checked,
                })
              }
              checked={dataForm.bloodCellsCountTest}
              style={{ width: "270px" }}
              label="تست شمارش سلول‌های خونی"
            />
            <CheckBoxBranch
              style={{ width: "180px" }}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  bioChemTest: e.target.checked,
                })
              }
              checked={dataForm.bioChemTest}
              label="تست بیوشیمی"
            />
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  hormonTest: e.target.checked,
                })
              }
              checked={dataForm.hormonTest}
              label="تست هورمونی"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="فیزیوتراپی"
          setChecked={setCheckedPhysiotherapy}
          checked={checkedPhysiotherapy}
        />
        {checkedPhysiotherapy && (
          <>
            <CheckBoxBranch
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  movementHelpEquipments: e.target.checked,
                })
              }
              checked={dataForm.movementHelpEquipments}
              label="تجهیزات کمک حرکتی"
            />
          </>
        )}
      </Box>
      <Box display="flex" just>
        <CheckBoxBranch
          label="دندانپزشکی"
          setChecked={setCheckedDentistry}
          checked={checkedDentistry}
        />
        {checkedDentistry && (
          <>
            <CheckBoxBranch style={{ width: "170px" }} label="کشیدن دندان" />
            <CheckBoxBranch style={{ width: "170px" }} label="ترمیم دندان" />
            <CheckBoxBranch style={{ width: "200px" }} label="عصب کشی دندان" />
            <CheckBoxBranch style={{ width: "200px" }} label="عصب کشی دندان" />
            <CheckBoxBranch style={{ width: "200px" }} label="جراحی لثه" />
          </>
        )}
      </Box>
      {checkedDentistry && (
        <InputLoginForm placeholder="دیگر اقدامات خود در زمینه دندان پزشکی را نام ببرید.">
          <DescriptionIcon />
        </InputLoginForm>
      )}
      <Box display="flex">
        <CheckBoxBranch
          label="ارجاع"
          setChecked={setCheckedErrand}
          checked={checkedErrand}
        />
        {checkedErrand && (
          <>
            <CheckBoxBranch label="ارجاع جهت جراحی" />
            <CheckBoxBranch label="ارجاع جهت بستری" />
            <CheckBoxBranch label="ارجاع رایگان بیمار" />
          </>
        )}
      </Box>
      {checkedErrand && (
        <InputLoginForm placeholder="دیگر زمینه های فعالیت ارجاع خود را نام ببرید.">
          <DescriptionIcon />
        </InputLoginForm>
      )}
    </Box>
  );
}
